import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CrearPolizaMadreComponent} from '../crear-poliza-madre/crear-poliza-madre.component';

@Component({
  selector: 'lista-modal-crear',
  templateUrl: './lista-modal-crear.component.html',
})
export class ListaModalCrear implements OnInit {

  isCountries: false;
  title: string;
  list: any;


  constructor(
    public dialogRef: MatDialogRef<CrearPolizaMadreComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.list = this.data.list;
    this.isCountries = this.data.isCountries;
  }

  onNoClick(result): void {
    this.dialogRef.close(result);
  }
}
